import {
  collection,
  CollectionReference,
  onSnapshot,
  orderBy,
  query,
  QueryDocumentSnapshot,
} from 'firebase/firestore'
import { useEffect, useMemo, useState } from 'react'
import { HelpItem } from '../types'
import { getEffectiveServices } from '../../../utils/firebaseServiceContext'

export const useHelpData = () => {
  const [docs, setDocs] = useState<QueryDocumentSnapshot<HelpItem>[]>([])

  const col = useMemo(() => {
    return collection(
      getEffectiveServices().firestore,
      'help',
    ) as CollectionReference<HelpItem>
  }, [])

  useEffect(() => {
    const unsub = onSnapshot(
      query(col, orderBy('createdAt', 'asc')),
      (snap) => {
        setDocs(snap.docs)
      }
    )

    return () => unsub()
  }, [col])

  return { docs, col }
}
